import DefaultStyleContainer from "../../components/button/defaultStyle";

const DefaultStyle = () => {
  return <DefaultStyleContainer />;
};

export default DefaultStyle;
